<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import ContactForm from '$lib/components/Global/ContactForm.svelte';
</script>

<div class="bg-white">
	<div class="container mx-auto py-12">
		<div
			class="items-top flex h-full flex-col justify-center gap-12 overflow-hidden 2xl:container md:flex-row"
		>
			<div class="lg:w-1/2">
				<div class="max-w-lg">
					<h3
						class="flex items-center gap-3 text-xs font-semibold uppercase tracking-0.14 text-secondary-bright lg:text-lg"
					>
						{$__('Contacto')}
					</h3>
					<div>
						<h1 class="mt-4 text-4xl text-dark lg:text-5xl lg:leading-54">
							{$__('Dê o primeiro passo e receba uma resposta em 24h')}
						</h1>
						<h2 class="mt-7 text-lg font-light text-dark-2 xl:text-xl">
							{$__(
								'Preencha os campos e entraremos em contacto, por e-mail ou telemóvel, entre as 9h e as 19h.'
							)}
						</h2>
					</div>
				</div>
			</div>
			<div class="relative lg:w-1/2">
				<ContactForm
					referral="contact_page"
					successText="Entraremos em contacto assim que possível para darmos início ao seu projeto!"
					gaEvent="Form Contact Us"
				/>
			</div>
		</div>
	</div>
</div>
